export default __webpack_public_path__ + "static/media/frozen.5aa3a2d3.png";